import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google'; // ✅ Import added

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="133957239578-7l81knjgre45512717apjg0ma8isrc14.apps.googleusercontent.com"> {/* ✅ Wrap here */}
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Performance
reportWebVitals();
